import { render, staticRenderFns } from "./Bando31Fase4.vue?vue&type=template&id=6d50fa10&scoped=true"
import script from "./Bando31Fase4.vue?vue&type=script&lang=js"
export * from "./Bando31Fase4.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d50fa10",
  null
  
)

export default component.exports